<template>
  <div
    class="mb-3 text-center"
  >
    <v-btn
      variant="text"
      @click="logout"
    >
      {{ $t('nav.logout') }}
      <font-awesome-icon
        :icon="['fas', 'sign-out-alt']"
        size="lg"
        class="ml-10"
      />
    </v-btn>
  </div>
</template>

<script>
import { useAuthStore } from '@/store/auth.module';
import { useUserStore } from '@/store/user.module';

export default {
  name: 'NavigationDrawerAppend',
  methods: {
    logout() {
      useAuthStore().logout()
        .then(() => {
          this.$router.push('/');
          useUserStore().clearUser();
        });
    },
  },
};
</script>
